import type { JSONSchemaType } from 'ajv';

import type { BaseArguments } from '../types/sdk-types';
import { basicIndexesSchema } from '../types/sdk-types';

export type Indexes = {
  indexes: IndexesSchema[];
};
export type IndexesSchema = {
  id: number;
  entityType: string;
  indexProvider: string;
  name: string;
  state: string;
  type: string;
  populationPercent: number;
  properties: string[] | null;
  labelsOrTypes: string[] | null;
};
export async function getIndexes({ queryCypher }: BaseArguments): Promise<Indexes> {
  const query = `SHOW INDEXES`;
  const res = await queryCypher(query);

  // Types are validated in e2e tests
  // eslint-disable-next-line
  const indexes = res.records.map(
    (record: {
      toObject: () => {
        id?: { low: number };
        lastRead?: object;
        readCount?: { low: number };
        owningConstraint?: string;
      };
    }) => {
      const obj = record.toObject();
      delete obj.lastRead;
      delete obj.owningConstraint;
      delete obj.readCount;
      return {
        ...obj,
        id: obj.id?.low,
      };
    },
  ) as Indexes['indexes'];

  return { indexes };
}
export const indexesSchema: JSONSchemaType<Indexes> = {
  type: 'object',
  properties: {
    indexes: {
      type: 'array',
      items: basicIndexesSchema,
    },
  },
  required: ['indexes'],
};
